class AccountSettings.UserProfileAttributesListView extends Backbone.View
  templateHeader: JST["backbone/templates/account_settings/user_profile_attributes/list"]
  templateRow: JST["backbone/templates/account_settings/user_profile_attributes/row"]

  events:
    'click .btn-add': '_createNew'

  initialize: (@options = {}) ->
    @collection = @options.collection
    @render()
    @collection.on('all', @_renderList)

  render: ->
    @$el.html(@templateHeader({self: @}))
    @tbody = @$el.find('tbody')
    @_renderList()
    @_makeItSortable()
    @

  _renderList: =>
    @tbody.empty()
    _.each @collection.models, (mod) =>
      row = $(@templateRow({self: @, model: mod}))
      row.find('.action-delete').on('click', mod, @_destroy)
      row.find('.action-edit').on('click', mod, @_edit)
      @tbody.append(row)

  _makeItSortable: ->
    @tbody.sortable({
      axis: 'y',
      cursor: 'move',
      helper:  @_getResizeFunction(),
      start: (e, ui) => $(ui.item).attr('data-previndex', ui.item.index())
      update: ((event, ui) =>
        newIndex = ui.item.index();
        oldIndex = $(ui.item).attr('data-previndex');
        $(ui.item).removeAttr('data-previndex');
        @collection.updatePositions(oldIndex, newIndex))
    })
    @tbody.disableSelection()

  _getResizeFunction: ->
    (e, ui) ->
      ui.children().each ->
        $(this).width($(this).width());
      return ui;

  _createNew: =>
    @_newEditorView(true, new @collection.model()).render()

  _edit: (ev) =>
    @_newEditorView(false, ev.data).render()

  _newEditorView: (isNew, model) ->
    new AccountSettings.UserProfileAttributesEditorView({new: isNew, model: model, collection: @collection})

  _destroy: (ev) ->
    translations =
      msg: I18n.t('monitoring.conversation_attributes.editor.destroy.msg')
      yes: 'Yes'

    model = ev.data
    noty {
      text: translations.msg,
      type: 'error'
      buttons: [
        {
          addClass: 'btn btn-primary', text: translations.yes, onClick: ($noty) ->
            $noty.close()
            model.destroy()
        },
        {
          addClass: 'btn btn-primary', text: 'No', onClick: ($noty) ->
            $noty.close()
        }
      ]
    }

  # Duplicated with response_template/response_template_list_view.js.coffee
  setLocale: ->   # I don't know why, but if I don't set the locale again, the template list.jst.ejs is not translated
    userLanguage = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage
    userLanguage = userLanguage.split('-')[0]
    I18n.locale = if userLanguage in ['en', 'es', 'pt'] then userLanguage else 'en'
